// extracted by mini-css-extract-plugin
export default {"badge":"StarBadge_badge__F8JPh","size-xs":"StarBadge_size-xs__+Aq9-","icon":"StarBadge_icon__WBs+J","size-sm":"StarBadge_size-sm__uORhm"};